var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRefreshing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7253 67.4629C27.7065 68.8513 46.2486 79.9874 62.0146 61.7571C68.5828 57.0126 78.8597 38.2547 70.7227 24.3837C64.4888 13.7349 51.0104 6.18139 40.1803 9.78395C-2.54981 13.6027 4.61794 58.0322 24.7253 67.4629Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9569 32.2039C33.0142 31.1786 34.2721 30.3663 35.6575 29.814C37.0428 29.2616 38.528 28.9804 40.0269 28.9864C42.0488 28.9827 44.0339 29.5073 45.7718 30.5044L43.4636 30.8014L43.8055 33.2434L50.4907 32.4019L49.6016 26L47.0712 26.33L47.3618 28.508C44.9623 27.0635 42.1649 26.3559 39.3397 26.4789C36.5144 26.6018 33.7944 27.5494 31.5393 29.1963C29.2841 30.8433 27.6001 33.112 26.71 35.7025C25.8198 38.293 25.7654 41.0832 26.554 43.7042L29.0161 43.0277C28.4659 41.1341 28.4483 39.1332 28.9652 37.2309C29.4821 35.3285 30.5147 33.5934 31.9569 32.2039V32.2039ZM53.3973 36.0813L50.9352 36.7908C51.6104 38.9122 51.6041 41.1812 50.9173 43.2992C50.2304 45.4171 48.8952 47.2847 47.0872 48.6562C45.2793 50.0277 43.0834 50.8388 40.7886 50.9827C38.4937 51.1267 36.2075 50.5967 34.2308 49.4626L36.5732 49.1491L36.2142 46.6906L29.5974 47.6146L30.5378 54L33.0853 53.6535L32.7605 51.5085C35.1773 52.9303 37.9846 53.61 40.8106 53.4575C43.6367 53.3051 46.3481 52.3278 48.5857 50.6551C50.8233 48.9824 52.4815 46.6931 53.3408 44.0905C54.2 41.488 54.2197 38.6949 53.3973 36.0813Z",
    fill: "url(#paint0_linear_36163_159017)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36163_159017",
    x1: 26.0411,
    y1: 39.9918,
    x2: 53.9957,
    y2: 39.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshing);
export default __webpack_public_path__ + "static/media/icon-refreshing.05690e4a28abbff4720d6f4faec16909.svg";
export { ForwardRef as ReactComponent };